import { RequestCardController } from './request-card.controller'

function requestCard () {
  return {
    restrict: 'E',
    scope: {
      request: '<'
    },
    templateUrl: '/workflow/directives/request-card/request-card-directive.html?$$REVISION$$',
    controller: RequestCardController
  }
}

export { requestCard }
